module.exports = __webpack_public_path__ + "img/free-to-play-banner.b36e638d.png";